import { render, staticRenderFns } from "./ForWfh.vue?vue&type=template&id=76e806ff"
import script from "./ForWfh.vue?vue&type=script&lang=js"
export * from "./ForWfh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports